import { appstr } from "@coreapp/utils/appstr";
import { Checkbox, Select } from "@theorgchartdev/storybook";
import { ConnectorInputComponent } from "../DataSetupInputComposite";

import {
  DATA_SOURCES_TEST_PREFIX,
  kKeyToLabelAndDefaultText,
  BuildAzureCloudEnvironmentOptions
} from "../Utils";
import { appcstr } from "@coreapp/utils/appcstr";

export const AdditionalPhotoCustomContent = props => {
  let content = null;
  switch (props.source) {
    case "Workday": {
      return (
        <Checkbox
          data-testid={`${DATA_SOURCES_TEST_PREFIX}-workday-photo-oauth`}
          onToggle={props.onChange("isOAuth")}
          checked={props.creds["isOAuth"] || false}
          id={"workday-photo-oauth-cb"}
          label={appstr("Use OAuth2.0 Authentication")}
          size={"medium"}
        />
      );
    }
    case "AzureAD": {
      // Build the input props for resourceId
      const key = "resourceId";
      const label = appcstr(kKeyToLabelAndDefaultText[key][0]);
      const placeholder = appcstr(kKeyToLabelAndDefaultText[key][1]);
      const value = props.creds[key] || "";
      const onChange = props.onChange(key);
      const cloudEnvironment = props.creds["cloudEnvironment"] || "commercial";

      return (
        <>
          <Select
            dataTestId={`${DATA_SOURCES_TEST_PREFIX}-photo-azuread-cloud-env-select`}
            selectSize={"medium"}
            inputOnly={false}
            label={appstr("Microsoft account type")}
            value={cloudEnvironment}
            options={BuildAzureCloudEnvironmentOptions(props.onSelectChange("cloudEnvironment"))}
          />
          <Checkbox
            data-testid={`${DATA_SOURCES_TEST_PREFIX}-azure-auth-v1`}
            onToggle={props.onChange("useAuthV1")}
            checked={props.creds["useAuthV1"]}
            id={"azure-auth-version-cb"}
            label={appstr("Use Auth V1")}
          />
          {props.creds["useAuthV1"] && (
            <ConnectorInputComponent
              dataTestId={`${DATA_SOURCES_TEST_PREFIX}-photo-connector-${props.source}-${key}`}
              key={label}
              label={label}
              placeholder={placeholder}
              value={value}
              onChange={onChange}
              size="medium"
            />
          )}
        </>
      );
    }
    default:
      return null;
  }
};
